export default [
  {
    path: '/admin/report/sale-item-details',
    name: 'sale-item-detail',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/sale-item-detail.vue')
  },
  {
    path: '/admin/report/stock-in-details',
    name: 'stock-in-detail',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/stock-in-detail.vue')
  },
  {
    path: '/admin/report/stock-in-summaries',
    name: 'stock-in-summary',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/stock-in-summary.vue')
  },
  {
    path: '/admin/report/detail-inventory-lists',
    name: 'report-detail-inventory-list',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/inventory/detail-inventory-list.vue')
  },
  {
    path: '/admin/report/summary-inventory-lists',
    name: 'report-summary-inventory-list',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/inventory/summary-inventory-list.vue')
  },
  {
    path: '/admin/report/product-item-lists',
    name: 'product-item-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/product-item-list.vue')
  },
  {
    path: '/admin/report/purchase-order-lists',
    name: 'purchase-order-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/purchase-order-list.vue')
  },
  {
    path: '/admin/report/purchase-order-summaries',
    name: 'purchase-order-summary',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/inventory/purchase-order-summary.vue')
  },
  {
    path: '/admin/report/monthly-sale-items',
    name: 'monthly-sale-item',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/monthly-sale-item.vue')
  },
  {
    path: '/admin/report/stock-transfers',
    name: 'report-stock-transfer',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/stock-transfer.vue')
  },
  {
    path: '/admin/report/yearly-sale-items',
    name: 'report-yearly-sale-item',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/yearly-sale-item.vue')
  },
  {
    path: '/admin/report/inventory/product-lists',
    name: 'report-product-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/product-list.vue')
  },
  {
    path: '/admin/report/inventory/product-serials',
    name: 'report-product-list',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/product-serial.vue')
  },
  {
    path: '/admin/report/inventory/product-addon-info',
    name: 'report-product-addon-info',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/inventory/product-addon-info/index.vue')
  },
  {
    path: '/admin/report/inventory/product-non-moving-stock',
    name: 'product-non-moving-stock',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/inventory/product-non-moving-stock/index.vue')
  },
  {
    path: '/admin/report/inventory/inventory-min-max',
    name: 'report-inventory-min-max',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/inventory-min-max.vue')
  },
  {
    path: '/admin/report/inventory/product-warranty-expireds',
    name: 'product-warranty-expired',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/inventory/product-warranty-expired.vue')
  },
  {
    path: '/admin/report/inventory/inventory-list-by-warehouses',
    name: 'inventory-list-by-warehouse',
    meta: { requiresAuth: true },
    component: () =>
      import('@/pages/report/inventory/inventory-list-by-warehouse/index.vue')
  },
  {
    path: '/admin/report/stock-adjustments',
    name: 'report-stock-adjustment',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/stock-adjustment.vue')
  },
  {
    path: '/admin/report/stock-returns',
    name: 'report-stock-return',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/stock-return.vue')
  },
  {
    path: '/admin/report/detail-transfers',
    name: 'report-detail-transfer',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/detail-transfer.vue')
  },
  {
    path: '/admin/report/transfer-pending-status',
    name: 'report-transfer-pending-status',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/transfer-pending-status.vue')
  },
  {
    path: '/admin/report/inventory/inventory-min-max-2',
    name: 'report-inventory-min-max-2',
    meta: { requiresAuth: true },
    component: () => import('@/pages/report/inventory/inventory-min-max-2.vue')
  }
]
